import { usePlacesHoveredSearchIdSelector } from '~/store/frontendState/places/places.selectors';
import { PlacesSearchRectangleOverlayContainer } from './placesSearchRectangleOverlay.container';

export const PlacesSearchHoverRectangleOverlayContainer = () => {
  const hoveredSearchId = usePlacesHoveredSearchIdSelector();

  if (!hoveredSearchId) {
    return null;
  }

  return (
    <PlacesSearchRectangleOverlayContainer searchId={hoveredSearchId} />
  );
};
